import { render, staticRenderFns } from "./DetailOrders.vue?vue&type=template&id=3d0b9041&"
import script from "./DetailOrders.vue?vue&type=script&lang=js&"
export * from "./DetailOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports